<template>
  <main>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="tabIndex">
          <b-tab>
            <template #title>
              {{ $t('all') }}
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('order') }}
            </template>
          </b-tab>
          <b-tab title-item-class="d-none">
            <template #title>
              {{ $t('barcode') }}
            </template>
          </b-tab>
          <b-tab title-item-class="d-none">
            <template #title>
              {{ $t('qrcode') }}
            </template>
          </b-tab>
          <b-tab title-item-class="d-none">
            <template #title>
              {{ $t('report') }}
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('export') }}
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('purchases') }}
            </template>
          </b-tab>
          <b-tab title-item-class="d-none">
            <template #title>
              {{ $t('transfer') }}
            </template>
          </b-tab>
          <b-tab title-item-class="d-none">
            <template #title>
              {{ $t('purchase_accessories') }}
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('expense') }}
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('local') }}
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('stocktaking') }}
            </template>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-sorting" v-if="['owner', 'admin', 'tech'].includes($store.state.user.role)">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus" />&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-5">{{ $t('printTemplate') }}</div>
            <div class="col-lg-4">{{ $t('info') }}</div>
            <div class="col-lg-3"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-5">
              <div>
                <b>{{ $t('name') }}: </b>
                <span>{{ item.name }}</span>
              </div>
              <div>
                <b>{{ $t('size') }}: </b>
                <span>{{ item.size }}</span>
              </div>
              <div v-if="item.gateway">
                <b>{{ $t('gateway') }}: </b>
                <span>{{ item.gateway.name }}</span>
              </div>
              <div>
                <b>{{ $t('quantity') }}: </b>
                <span>{{ item.quantity }}</span>
              </div>
              <div>
                <label class="badge badge-primary">{{ item.type === 'product-local' ? $t('local') : $t(item.type) }}</label>&nbsp;
                <label v-if="item.default" class="badge badge-success">{{ $t('default') }}</label>
              </div>
            </div>
            <div class="col-lg-4">
              <div>
                <b>{{ $t('createTime') }}: </b>
                <span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </div>
              <div v-if="item.createdBy">
                <b>{{ $t('createdBy') }}: </b>
                <span>{{ item.createdBy.name }}</span>
              </div>
              <div>
                <b>{{ $t('updateTime') }}: </b>
                <span>{{ item.updateTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </div>
              <div v-if="item.updatedBy">
                <b>{{ $t('updatedBy') }}: </b>
                <span>{{ item.updatedBy.name }}</span>
              </div>
              <div>
                <label v-if="item.active" class="badge badge-success">{{ $t('activated') }}</label>
                <label v-if="!item.active" class="badge badge-danger">{{ $t('deactivated') }}</label>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col" v-if="['owner', 'admin', 'tech'].includes($store.state.user.role)">
                    <button @click="preview(item)" type="button" class="btn btn-sm btn-warning mr-1">
                      <font-awesome-icon icon="eye" />&nbsp;{{ $t('preview') }}
                    </button>
                    <button @click="update(item._id)" type="button" class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="edit" />&nbsp;{{ $t('edit') }}
                    </button>
                    <button @click="del(item._id)" type="button"
                            class="btn btn-sm btn-danger mr-1">
                      <font-awesome-icon icon="trash" />&nbsp;{{ $t('delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>

      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal v-model="showForm" modal-class="modal-fullscreen" size="xl" :title="formTitle" @ok="save"
             no-close-on-backdrop no-enforce-focus>
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-4">
              <form-input :label="$t('name')" :placeholder="$t('enterTemplateName')" :model="formModel" attribute="name"
                          :errors="formErrors"></form-input>
            </div>
            <div class="col-md-4">
              <form-select :disabled="!!tabIndex" :label="$t('type')" :model="formModel" attribute="type"
                           :options="typeOptions" :errors="formErrors" @change="typeChange"></form-select>
            </div>
            <div class="col-md-4">
              <form-select :disabled="!formModel.type" :label="$t('size')" :model="formModel" attribute="size"
                           :options="sizeOptions" :errors="formErrors"></form-select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <form-input :label="$t('quantity')" :placeholder="$t('enterQuantity')" :model="formModel"
                          attribute="quantity"
                          :errors="formErrors"></form-input>
            </div>
            <div class="col-md-4">
              <form-select :label="$t('gateway')" :model="formModel" attribute="gateway"
                           :options="gatewayOptions" :errors="formErrors"></form-select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <form-checkbox :chk-label="$t('active')" :model="formModel" attribute="active"
                             :errors="formErrors"></form-checkbox>
            </div>
          </div>
          <div>
            <label>{{ $t('content') }}</label>
            <div class="row">
              <form-email-editor class="col-8" :model="formModel" attribute="content"
                                 :errors="formErrors"></form-email-editor>
              <div class="col-4">
                <div class="tile">
                  <b-form-input class="mr-1 mb-4" v-model="templateParamKey" @keyup="getTemplateParams"
                                :placeholder="$t('templateParamKey')"></b-form-input>
                  <div style="max-height: 398px; overflow-y: auto;">
                    <div v-if="templateParams.length">
                      <table class="w-100">
                        <tr v-for="param in templateParams" :key="param.value">
                          <td class="border-bottom pt-2 pb-2">
                            <button class="btn btn-outline-primary"
                                    @click="copy(`{${param.value}}`)">
                              <span v-pre>{</span>{{ param.value }}<span v-pre>}</span>
                              <font-awesome-icon class="ml-2" @click.stop="showFormConfig"
                                                 v-if="param.value === 'productCustom'"
                                                 icon="cog" />
                            </button>
                          </td>
                          <td class="border-bottom pt-2 pb-2">{{ param.text }}</td>
                        </tr>
                      </table>
                    </div>
                    <div v-else-if="!formModel.type" class="text-center text-danger">
                      <span>{{ $t('chooseTemplateType') }}</span>
                    </div>
                    <div v-else class="text-center text-danger">
                      <span>{{ $t('notFoundSearch') }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <form-textarea :label="$t('desc')" :model="formModel" attribute="desc" :errors="formErrors"></form-textarea>
        </div>
      </div>
    </b-modal>
    <b-modal v-model="showFormPreview" size="lg" :title="$t(formPreviewTitle)">
      <div style="display: flex; justify-content: center; margin-top: 15px;" v-html="previewContent"></div>
    </b-modal>
    <b-modal v-model="showFormProductCustom" size="lg" :title="$t('configureColumns')" @hide="cancel">
      <div class="row">
        <div class="col-6" style="max-height: 500px; overflow-y: auto;">
          <div class="c-sorting pb-2" style="background-color: #fafafa">
            <h6 class="mb-3">{{ $t('addColumn') }}</h6>
            <draggable
              class="list-group"
              v-model="productParams"
              group="productParams"
            >
              <template v-if="productParams.length">
                <div class="list-group-item mb-1 pointer" v-for="param in productParams" :key="param.value">
                  <div class="d-flex justify-content-between">
                    <div>
                      <span>
                        <font-awesome-icon icon="ellipsis-v" />
                        <font-awesome-icon icon="ellipsis-v" />
                      </span>&ensp;
                      <span>{{ param.text }}</span>
                    </div>
                    <div>
                      <font-awesome-icon class="hover-pointer" icon="plus" @click="moveItem(param, 'display')" />
                    </div>
                  </div>
                </div>
              </template>
              <div v-else class="text-center mt-3">
                {{ $t('noData') }}
              </div>
            </draggable>
          </div>
        </div>
        <div class="col-6" style="max-height: 500px; overflow-y: auto;">
          <div class="c-sorting pb-2" style="background-color: #fafafa" v-if="formModel.productParam">
            <h6 class="mb-3">{{ $t('displayColumn') }}</h6>
            <draggable
              class="list-group"
              v-model="formModel.productParam.params"
              group="productParams"
            >
              <template
                v-if="formModel.productParam && formModel.productParam.params && formModel.productParam.params.length">
                <div class="list-group-item mb-1" v-for="param in formModel.productParam.params" :key="param.value">
                  <div class="d-flex justify-content-between">
                    <div>
                      <span>
                        <font-awesome-icon icon="ellipsis-v" />
                        <font-awesome-icon icon="ellipsis-v" />
                      </span>&ensp;
                      <span>{{ param.text }}</span>
                    </div>
                    <div>
                      <font-awesome-icon class="hover-pointer" icon="times" @click="moveItem(param, 'add')" />
                    </div>
                  </div>
                </div>
              </template>
              <div v-else class="text-center mt-3">
                {{ $t('noData') }}
              </div>
            </draggable>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-between align-items-center">
          <div class="d-flex flex-row">
            <b-form-checkbox v-model="formModel.productParam.isBorder" class="mr-4" switch>
              {{ $t('border') }}
            </b-form-checkbox>
            <b-form-checkbox v-model="formModel.productParam.isTitle" class="mr-4" switch>
              {{ $t('title') }}
            </b-form-checkbox>
          </div>
          <div>
            <button class="btn btn-secondary mr-1 ml-1" @click="cancel">Cancel</button>
            <button class="btn btn-primary mr-1 ml-1" @click="ok">OK</button>
          </div>
        </div>
      </template>
    </b-modal>
  </main>
</template>

<script>
import List from '../../mixins/List'
import CRUD from '../../mixins/CRUD'
import Draggable from 'vuedraggable'
import _ from 'lodash'

export default {
  mixins: [List, CRUD],
  components: { Draggable },
  data: function() {
    return {
      service: '/print-template',
      autoLoad: true,
      defaultFormModel: {
        name: null,
        size: null,
        type: null,
        content: null,
        desc: null,
        gateway: null,
        quantity: 1,
        active: true,
        productParam: {
          params: [],
          isBorder: false,
          isTitle: false
        }
      },
      defaultFilterFormModel: {
        type: null
      },
      tabIndex: 0,
      previewContent: null,
      showFormPreview: false,
      showFormProductCustom: false,
      typeOptions: [
        { value: null, text: this.$t('chooseType') },
        { value: 'order', text: this.$t('order') },
        // { value: 'barcode', text: this.$t('barcode') },
        // { value: 'qrcode', text: this.$t('qrcode') },
        // { value: 'report', text: this.$t('report') },
        { value: 'export', text: this.$t('export') },
        { value: 'purchases', text: this.$t('purchases') },
        // { value: 'transfer', text: this.$t('transfer') },
        // { value: 'purchase_accessories', text: this.$t('purchase_accessories') },
        { value: 'expense', text: this.$t('expense') },
        { value: 'product-local', text: this.$t('local') },
        { value: 'stocktaking', text: this.$t('stocktaking') }
      ],
      templateType: [null, 'order', 'barcode', 'qrcode', 'report', 'export', 'purchases', 'transfer', 'purchase_accessories', 'expense', 'product-local', 'stocktaking'],
      formPreviewTitle: '',
      sizeOptions: [{ value: null, text: this.$t('chooseSize') }],
      defaultSizeOptions: [
        {
          type: ['order', 'barcode', 'qrcode', 'report', 'export', 'purchases', 'transfer', 'purchase_accessories', 'expense', 'product-local', 'stocktaking'],
          value: null,
          text: this.$t('chooseSize')
        }
      ],
      gatewayOptions: [
        { value: null, text: this.$t('chooseGateway') }
      ],
      templateParams: [],
      productParams: [],
      defaultProductParams: [],
      addHistory: [],
      displayHistory: [],
      borderHistory: false,
      titleHistory: false,
      templateParamKey: null
    }
  },
  methods: {
    preview(item) {
      let itemSize = this.defaultSizeOptions.find(size => size.value === item.size)
      if (item.desc) {
        this.previewContent = `<div style="width: ${itemSize.width}cm; min-height: ${itemSize.height ? itemSize.height + 'cm' : 'fit-content'}; display: flex; justify-content: space-around; flex-wrap: wrap;">${item.desc}</div>`
      } else {
        this.previewContent = `<p class="text-danger text-center">${this.$t('noPreview')}</p>`
      }
      this.formPreviewTitle = item.name
      this.showFormPreview = true
    },
    save: function(evt, fn, customUrl) {
      if (evt) {
        evt.preventDefault()
      }
      let loader = this.$loading.show()
      let method = 'post'
      let url = this.service
      if (this.formModel.id) {
        method = 'put'
        url += '/' + this.formModel.id
      }
      if (customUrl) {
        url = customUrl
      }
      let data = _.cloneDeep(this.formModel)
      data.productParam.params = JSON.stringify(data.productParam.params)
      this.$service({ url: url, method: method, data: data }).then(response => {
        this.showForm = false
        if (this.load) {
          this.load()
        }
        if (this.reloadBus) {
          this.$bus.$emit(this.reloadBus)
        }
        if (fn) {
          fn()
        }
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t(this.formModel.id ? 'updated' : 'created'),
            icon: 'success'
          })
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t(this.formModel.id ? 'updateFailed' : 'createFailed'),
            icon: 'error'
          })
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          })
          this.showForm = false
        } else {
          this.formErrors = error.response.data
        }
      }).finally(() => {
        loader.hide()
      })
    },
    create: function() {
      this.formModel = {}
      this.formModel = Object.assign({}, this.formModel, this.defaultFormModel)
      this.formModel.type = this.templateType[this.tabIndex]
      this.formModel.productParam = {
        params: [],
        isBorder: false,
        isTitle: false
      }
      this.productParams = [...this.defaultProductParams]
      this.addHistory = [...this.productParams]
      this.displayHistory = [...this.formModel.productParam.params]
      this.borderHistory = this.formModel.productParam.isBorder
      this.titleHistory = this.formModel.productParam.isTitle
      this.templateParamKey = null
      this.getTemplateParams()
      this.formTitle = this.$t('create')
      this.formErrors = []
      this.showForm = true
    },
    update: function(id) {
      let loader = this.$loading.show()
      this.formModel.productParam.params = []
      this.$service.get(this.service + '/' + id).then(response => {
        this.formModel = {}
        this.formTitle = this.$t('update')
        this.formErrors = []
        this.showForm = true
        this.formModel = response.data
        this.formModel.productParam.params = JSON.parse(response.data.productParam.params)
        this.productParams = this.defaultProductParams.filter(item1 => !this.formModel.productParam.params.some(item2 => item2.value === item1.value))
        this.addHistory = [...this.productParams]
        this.displayHistory = [...this.formModel.productParam.params]
        this.borderHistory = this.formModel.productParam.isBorder
        this.titleHistory = this.formModel.productParam.isTitle
        this.templateParamKey = null
        this.getTemplateParams()
        this.formModel.id = id
      }).finally(() => {
        loader.hide()
      })
    },
    async getSize() {
      await this.$bgService.get(this.service + '/size/default')
        .then(response => {
          if (response.data.length) {
            response.data.forEach(item => {
              this.defaultSizeOptions.push(item)
            })
          }
        })
    },
    async getGateway() {
      await this.$bgService.get('/carrier-gateway', { params: { page: 1, pageSize: 1000 } })
        .then(response => {
          if (response.data && response.data.docs.length) {
            response.data.docs.forEach(item => {
              this.gatewayOptions.push({ value: item._id, text: item.name })
            })
          }
        })
    },
    async getTemplateParams() {
      await this.$bgService.get(this.service + '/params/template', {
        params: {
          key: this.templateParamKey,
          group: this.formModel.type
        }
      })
        .then(response => {
          this.templateParams = response.data
        })
    },
    async getProductParams() {
      await this.$bgService.get(this.service + '/params/product')
        .then(response => {
          if (response.data.length) {
            this.defaultProductParams = response.data
          }
        })
    },
    copy(str) {
      this.$copyText(str).then(() => {
        this.$swal({
          text: this.$t('copied', [str]),
          icon: 'success',
          toast: true,
          timer: 2000,
          position: 'top-right'
        })
      }, () => {
        this.$swal({
          title: this.$t('error'),
          text: this.$t('copyFailed'),
          icon: 'error'
        })
      })
    },
    ok() {
      this.showFormProductCustom = false
      this.addHistory = [...this.productParams]
      this.displayHistory = [...this.formModel.productParam.params]
      this.borderHistory = this.formModel.productParam.isBorder
      this.titleHistory = this.formModel.productParam.isTitle
    },
    cancel() {
      this.showFormProductCustom = false
      this.productParams = [...this.addHistory]
      this.formModel.productParam.params = [...this.displayHistory]
      this.formModel.productParam.isBorder = this.borderHistory
      this.formModel.productParam.isTitle = this.titleHistory
    },
    showFormConfig() {
      this.showFormProductCustom = true
    },
    moveItem(param, targetColumn) {
      const sourceColumn = targetColumn === 'add' ? this.formModel.productParam.params : this.productParams
      const destinationColumn = targetColumn === 'add' ? this.productParams : this.formModel.productParam.params
      const index = sourceColumn.findIndex(p => p.value === param.value)
      if (index !== -1) {
        sourceColumn.splice(index, 1)
        destinationColumn.push(param)
      }
    },
    typeChange() {
      this.formModel.size = null
    }
  },
  mounted() {
    Promise.all([
      this.getSize(),
      this.getGateway(),
      this.getTemplateParams(),
      this.getProductParams()
    ])
  },
  watch: {
    tabIndex: function() {
      this.defaultFilterFormModel.type = this.templateType[this.tabIndex]
      this.filterFormModel.type = this.templateType[this.tabIndex]
      this.load()
    },
    'formModel.type': {
      handler(val) {
        if (val) {
          this.sizeOptions = this.defaultSizeOptions.filter(item => item.type && item.type.includes(val))
        }
        this.getTemplateParams()
      }
    }
  },
  i18n: {
    messages: {
      en: {
        order: 'Orders',
        barcode: 'Barcode',
        qrcode: 'QRCode',
        report: 'Delivery record',
        export: 'Delivered',
        purchases: 'Purchases',
        transfer: 'Warehouse transfer',
        stocktaking: 'Stocktaking',
        purchase_accessories: 'Import materials',
        local: 'Warehouse transfer',
        chooseType: 'Choose type',
        content: 'Content',
        preview: 'Preview',
        size: 'Size',
        chooseSize: 'Choose size',
        copied: 'Copied {0}',
        copyFailed: 'Copy failed',
        configureColumns: 'Configure display columns',
        border: 'Border',
        title: 'Title',
        noPreview: 'No preview available',
        noData: 'No data',
        addColumn: 'Add column',
        displayColumn: 'Display column',
        gateway: 'Logistics company',
        chooseGateway: 'Choose logistics company',
        enterTemplateName: 'Enter the print template name',
        enterQuantity: 'Enter the number of prints',
        default: 'Default',
        active: 'Activated',
        quantity: 'Number of prints',
        printTemplate: 'Print template',
        createdBy: 'Created by',
        updatedBy: 'Updated by',
        templateParamKey: 'Enter the key you want to find',
        expense: 'Expense',
        chooseTemplateType: 'Please select the type for the printed sample'
      },
      vi: {
        order: 'Đơn hàng',
        barcode: 'Barcode',
        qrcode: 'QRCode',
        report: 'Biên bản giao hàng',
        export: 'Xuất hàng',
        purchases: 'Nhập hàng',
        transfer: 'Chuyển kho',
        stocktaking: 'Kiểm hàng',
        purchase_accessories: 'Nhập nguyên phụ liệu',
        local: 'Chuyển kho',
        chooseType: 'Chọn loại',
        content: 'Nội dung',
        preview: 'Xem trước',
        size: 'Kích thước',
        chooseSize: 'Chọn kích thước',
        copied: 'Đã sao chép {0}',
        copyFailed: 'Sao chép thất bại',
        configureColumns: 'Cấu hình cột hiển thị',
        border: 'Viền',
        title: 'Tiêu đề',
        noPreview: 'Không có bản xem trước',
        noData: 'Không có dữ liệu',
        addColumn: 'Thêm cột',
        displayColumn: 'Cột hiển thị',
        gateway: 'Hãng vận chuyển',
        chooseGateway: 'Chọn hãng vận chuyển',
        enterTemplateName: 'Nhập tên mẫu in',
        enterQuantity: 'Nhập số liên in',
        default: 'Mặc định',
        active: 'Được hoạt động',
        quantity: 'Số liên in',
        printTemplate: 'Mẫu in',
        createdBy: 'Tạo bởi',
        updatedBy: 'Cập nhật bởi',
        templateParamKey: 'Nhập key cần tìm',
        expense: 'Phiếu thu chi',
        chooseTemplateType: 'Vui lòng chọn loại cho mẫu in'
      }
    }
  }
}
</script>

<style>
.modal-fullscreen .modal-dialog {
  max-width: 98%;
}

.list-group-item:hover {
  cursor: grab;
}

.hover-pointer:hover {
  cursor: pointer;
}
</style>